import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import { appNamedRoutes } from 'routes';
import { tableNoResultsDefault } from '../helpers/TableHelpers';
import AccountPlayersPreviewHeader from './AccountPlayersPreviewHeader';
import AccountPlayersPreviewRow from './AccountPlayersPreviewRow';

const ACCOUNT_PLAYERS_PREVIEW_COLUMN_NUMBER = 7;

const AccountPlayersPreview = ({ accountId, accountPlayers, meta, onAccountPlayer }) => {
  const childrenLink = { pathname: appNamedRoutes.accountPlayers, search: `?accounts=${accountId}`}
  const rows = accountPlayers.map(row => (
    <AccountPlayersPreviewRow key={`${row.id}`} data={row} accountId={accountId} onAccountPlayer={onAccountPlayer}/>
  ));
  return (
    <div className='column small-12 medium-8'>
      <strong>Players</strong>
      <Link className='u-margin-left--base cs-txt-link--sp-blue' to={childrenLink}>
        View All {meta.totalCount} Children
      </Link>
      <div className='table-scroll u-margin-top--base u-margin-bottom--gutter2x'>
        <table className='o-table o-table--bordered'>
          <AccountPlayersPreviewHeader />
          <tbody>
            { (isEmpty(accountPlayers) && meta.totalPages === 0) ? tableNoResultsDefault(ACCOUNT_PLAYERS_PREVIEW_COLUMN_NUMBER) : rows }
          </tbody>
        </table>
      </div>
    </div>
  );
}

AccountPlayersPreview.propTypes = {
  accountId: PropTypes.number.isRequired,
  accountPlayers: PropTypes.arrayOf(PropTypes.object).isRequired,
  meta: PropTypes.object.isRequired,
  onAccountPlayer: PropTypes.func.isRequired,
}

export default AccountPlayersPreview;
